import { render, staticRenderFns } from "./LinkExpired.vue?vue&type=template&id=6dc0c4b9&scoped=true"
import script from "./LinkExpired.vue?vue&type=script&lang=js"
export * from "./LinkExpired.vue?vue&type=script&lang=js"
import style0 from "./LinkExpired.vue?vue&type=style&index=0&id=6dc0c4b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0c4b9",
  null
  
)

export default component.exports